import React from 'react';
import css from '../DetailsTab.scss';
import OfficeHours from './OfficeHours';
import MyLocations from './MyLocations';
import PropTypes from 'prop-types';
import { SFEntityID, StaffAppointmentPreferences, StaffProfilePrivileges } from 'utils/types';
import ExternalCalendarSyncPreferences from './ExternalCalendarSyncPreferences';
import { StaffNotificationPreferences } from 'utils/types';
import CalendarManagers from './CalendarManagers';

/**
 * @param {Object} props - see prop types
 * @returns {node} the Appointment Preference tab of the staff's profile.
 */
const AppointmentPreferenceDetails = (props) => {
    return (
        <div className={css['header-block']}>
            <h1>Appointment Preferences</h1>
            <hr className={css['divider']} />
            <div className={css['content-block']}>
                <p>Customize your appointment default settings, add locations, and designate calendar managers.</p>
                <OfficeHours appointmentPreferences={props.appointmentPreferences}
                             setValue={(newAppointmentPreferences) => props.setValue({appointmentPreferences: newAppointmentPreferences})} />
                <ExternalCalendarSyncPreferences hasSchedule={!!props.scheduleId}
                                                 exchangeAccounts={props.exchangeAccounts}
                                                 googleFreeBusyPopupRouteLink={props.googleFreeBusyPopupRouteLink}
                                                 exchangeFreeBusyPopupLink={props.exchangeFreeBusyPopupLink}
                                                 notificationPreferences={props.notificationPreferences}
                                                 privileges={props.privileges}
                                                 setValue={(newNotificationPreferences) => props.setValue({notificationPreferences: newNotificationPreferences})}
                                                 externalCalendarPreferenceSync={props.externalCalendarPreferenceSync} />
                <MyLocations isIE={props.isIE}
                             userId={props.userId} />
                <CalendarManagers calendarLockingEnabled={props.privileges.calendarLockingEnabled}
                                  isCalendarLocked={props.isCalendarLocked}
                                  isIE={props.isIE}
                                  userId={props.userId} />
            </div>
        </div>
    );
};

AppointmentPreferenceDetails.propTypes = {
    appointmentPreferences: StaffAppointmentPreferences,
    exchangeAccounts: PropTypes.string,
    exchangeFreeBusyPopupLink: PropTypes.string,
    externalCalendarPreferenceSync: PropTypes.func,
    googleFreeBusyPopupRouteLink: PropTypes.string,
    isCalendarLocked: PropTypes.bool,
    isIE: PropTypes.bool,
    notificationPreferences: StaffNotificationPreferences,
    privileges: StaffProfilePrivileges,
    scheduleId: PropTypes.number,
    setValue: PropTypes.func,
    userId: SFEntityID.isRequired
};

export default AppointmentPreferenceDetails;
